import React from 'react';
import { SVGIcon } from '../SVGIcon/SVGIcon';

interface ContactInfoProps {
  title: string;
  value: string;
  href: string;
  icon: 'phone' | 'email';
}

export const ContactInfo: React.FC<ContactInfoProps> = ({
  title,
  value,
  href,
  icon,
}) => {
  return (
    <a
      href={href}
      className="flex items-center transition-opacity hover:opacity-80"
    >
      <div className="flex h-8 w-8 items-center justify-center">
        {icon === 'phone' ? (
          <SVGIcon name="i" height={28} width={28} size="lg" />
        ) : (
          <SVGIcon name="chat-messages" height={28} width={28} size="lg" />
        )}
      </div>
      <div className="flex flex-col pl-3">
        <span className="font-inter text-sm font-medium tracking-wider text-grayText">
          {title}
        </span>
        <span className="mt-1 font-archivo text-[17px] font-extrabold text-text-primary">
          {value}
        </span>
      </div>
    </a>
  );
};

export default ContactInfo;
